{
  "name": "@xiboplayer/stats",
  "version": "0.7.23",
  "description": "Proof of play tracking, stats reporting, and CMS logging",
  "type": "module",
  "main": "./src/index.js",
  "types": "./src/index.d.ts",
  "exports": {
    ".": "./src/index.js",
    "./collector": "./src/stats-collector.js"
  },
  "scripts": {
    "test": "vitest run",
    "test:watch": "vitest",
    "test:coverage": "vitest run --coverage"
  },
  "dependencies": {
    "@xiboplayer/utils": "workspace:*"
  },
  "devDependencies": {
    "fake-indexeddb": "^6.2.5",
    "vitest": "^4.1.2"
  },
  "keywords": [
    "xibo",
    "digital-signage",
    "proof-of-play",
    "statistics",
    "reporting"
  ],
  "author": "Pau Aliagas <linuxnow@gmail.com>",
  "license": "AGPL-3.0-or-later",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/xibo-players/xiboplayer.git",
    "directory": "packages/stats"
  },
  "homepage": "https://xiboplayer.org"
}
